import ui from "./ui.module.css";

// The Teacher App's white header with the logo. No navigation: a learner only
// ever sees the task in front of them. `progress` shows the lesson player's
// progress bar while an activity is open.
const Frame = ({ progress, centered, narrow, children }) => (
  <>
    <header className={ui.header}>
      <div className={ui.headerInner}>
        <img
          src={`${process.env.PUBLIC_URL}/thutotime-logo.svg`}
          alt="Thuto Time"
          className={ui.logo}
        />
        {progress && (
          <progress
            className={ui.progress}
            value={progress.current}
            max={progress.total}
            aria-label={`Part ${progress.current} of ${progress.total}`}
          />
        )}
      </div>
    </header>
    <main
      className={[ui.page, centered && ui.centered, narrow && ui.narrow]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </main>
  </>
);

export default Frame;
